import React from "react";
import { UpdateDeploymentProps } from "./DeploymentDetails";
import { DeploymentEditorLegacy } from "./DeploymentEditorLegacy";
import { DeploymentEditorRegional } from "./DeploymentEditorRegional";

interface DeploymentEditorProps {
  basePath?: string;
  resourceAppId?: string;
  version?: string;
  updateDeployment?: UpdateDeploymentProps;
  onDeploymentUpdated?: () => void;
}

const supportRegionalDeployments =
  process.env.REACT_APP_SUPPORT_REGIONAL_DEPLOYMENTS === "true";

export const DeploymentEditor: React.FC<DeploymentEditorProps> = (props) => {
  if (!supportRegionalDeployments) {
    return (
      <DeploymentEditorLegacy
        basePath={props.basePath}
        resourceAppId={props.resourceAppId}
        version={props.version}
        updateDeployment={props.updateDeployment}
      />
    );
  }

  return (
    <DeploymentEditorRegional
      basePath={props.basePath}
      resourceAppId={props.resourceAppId}
      version={props.version}
      updateDeployment={props.updateDeployment}
      onDeploymentUpdated={props.onDeploymentUpdated}
    />
  );
};
